<template>
  <v-card
    flat
    id="drugs-info"
    class="white drugs-info vetalfa-view"
    :max-width="_getMaxWidth()"
  >
    <div class="vetalfa-global-header" ref="screenHeader">
      <!-- Header -->
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :isDrugsManagement="isDrugsManagement"
        :title="category ? category.portugueseName : null"
        hasHeaderOptions
        :breadcrumb="!!drug ? drug.name : null"
      ></vetalfa-small-header>

      <!-- Tabs Title -->
      <v-col cols="12" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" justify="center">
          <v-tabs
            v-show="!isDrugsManagement"
            v-model="tabModel"
            v-if="drug"
            background-color="transparent"
            color="#193153 !important"
            centered
            height="50px"
            class="mt-2 vetalfa-max-width"
            icons-and-text
            grow
          >
            <v-tab
              class="text-capitalize"
              v-bind:style="tabStyle"
              v-for="(tab, index) in tabs"
              :key="tab.name"
              @click="
                $vuetify.goTo(0, {
                  duration: 0,
                  offset: 0,
                  easing: 'easeInOutCubic',
                })
              "
            >
              {{ tab.name }}
              <v-icon
                v-bind:style="
                  index == tabModel ? 'color:#193153' : 'color:#393a3a'
                "
                >{{ tab.icon }}</v-icon
              >
            </v-tab>
          </v-tabs>
        </v-row>
      </v-col>

      <!-- Summary -->
      <v-col cols="12" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" justify="center">
          <vetalfa-drugs-header
            v-if="drug"
            :name="drug.name"
            :description="drug.description"
            :isDrugsManagement="isDrugsManagement"
            displayInteractions
            class="vetalfa-max-width my-4 px-2"
          ></vetalfa-drugs-header>
        </v-row>
      </v-col>
    </div>

    <!-- Tabs Content -->
    <div v-if="drug && !drug.vaccines_suplements_serums" ref="screenContent">
      <v-tabs-items v-model="tabModel" class="drugs-info-tab-item">
        <v-tab-item v-show="tabModel == 0 && drug.info">
          <vetalfa-general-tab
            :sections="drug.info"
            :references="references"
          ></vetalfa-general-tab>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 1 && drug.doses">
          <vetalfa-doses-tab
            :isDrugsManagement="isDrugsManagement"
            :doses="drug.doses"
          ></vetalfa-doses-tab>
          <vetalfa-section-title
            v-if="!!drug.internalReferences && !!drug.internalReferences.length"
            prop="Correlatos"
          ></vetalfa-section-title>
          <vetalfa-internal-references
            v-if="!!drug.internalReferences && !!drug.internalReferences.length"
            :internalReferences="drug.internalReferences || []"
          ></vetalfa-internal-references>
          <div class="navigation-blank-space"></div>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 2 && drug.attention">
          <vetalfa-general-tab :sections="drug.attention"></vetalfa-general-tab>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 3">
          <vetalfa-products-tab
            :isDrugsManagement="isDrugsManagement"
            :veterinary_products="drug.veterinary_products"
            :human_products="drug.human_products"
          ></vetalfa-products-tab>
        </v-tab-item>
      </v-tabs-items>
      <div class="navigation-blank-space"></div>
    </div>
    <div v-if="drug && drug.vaccines_suplements_serums" ref="screenContent">
      <vetalfa-products-tab
        :isDrugsManagement="isDrugsManagement"
        :veterinary_products="drug.veterinary_products"
        :human_products="drug.human_products"
      ></vetalfa-products-tab>
      <div class="navigation-blank-space"></div>
    </div>
    <vetalfa-ai-content-assistant
      v-if="drug"
      :contextData="drug"
      pageType="drug"
      :pageName="drug.name"
    />
  </v-card>
</template>

<style>
.drugs-info-tab-item {
  height: 100%;
  width: 100% !important;
}
.v-tab {
  min-width: 0 !important;
  box-shadow: none !important;
  font-size: 12px !important;
}
.v-tab:not(.v-tab--active) {
  color: #393a3a !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import enums from "@/constants/enums.js";
import parameters from "@/constants/parameters.js";
import InternalReferences from "@/components/InternalReferences.vue";
export default {
  name: "DrugsInfo",
  components: {
    "vetalfa-internal-references": InternalReferences,
  },
  props: {
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (!this.drug || this.drug.id != id) {
          this.setupDrug();
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    ...mapActions("drugs", ["openCategoryItem"]),
    ...mapActions("preferences", ["trackContentOpen"]),
    ...mapMutations("drugs", ["setDrugTab"]),
    ...mapMutations("general", [
      "setLoadingOff",
      "setLoadingOn",
      "setGoToSection",
    ]),
    setupDrug() {
      if (!this.isDrugsManagement) {
        this.openCategoryItem({
          category: this.$route.params.category,
          id: this.$route.params.id,
          redirect: false,
        }).then(() => {
          this._setupScreenSizes(this);
          this.trackContentOpen();
        });
      }
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "veterinaryProductsMap",
      "humanProductsMap",
      "drug",
      "drugTab",
      "category",
    ]),
    tabs() {
      let arr = [];
      if (this.drug && !this.drug.vaccines_suplements_serums) {
        enums.DRUGS_TABS.forEach((el, index) => {
          if (
            index != parameters.DRUGS_PRODUCT_TAB ||
            !!this.isDrugsManagement ||
            this.drug.human_products.length > 0 ||
            this.drug.veterinary_products.length > 0
          ) {
            arr.push(el);
          }
        });
      } else if (this.drug && !!this.drug.vaccines_suplements_serums) {
        arr.push(enums.DRUGS_TABS[parameters.DRUGS_PRODUCT_TAB]);
      }
      return arr;
    },
    tabStyle() {
      let width =
        (this.screenSize > this._getMaxWidth()
          ? this._getMaxWidth()
          : this.screenSize - 4) / 4;
      return "width:" + width + "px !important;";
    },
    tabModel: {
      get() {
        return this.drugTab;
      },
      set(tabModel) {
        this.setDrugTab(tabModel);
      },
    },
    references() {
      let arr = [];
      this.drug.references.forEach((reference) => {
        arr.push(reference);
      });
      this.drug.doses.forEach((dose) => {
        if (dose.references) {
          dose.references.forEach((reference) => {
            arr = this._removeFromArrayWithName(arr, reference.name);
            arr.push(reference);
          });
        }
      });
      return arr;
    },
  },
  data() {
    return {
      screenSize: 1200,
      headerHeight: 0,
      showHumProduct: false,
      showVetProduct: false,
    };
  },
  mounted() {
    this.screenSize =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      document.getElementById("drugs-info").clientWidth ||
      screenSize;
    this.setupDrug();
  },
};
</script>